import React, { useState } from "react"

import { gql, useQuery } from "urql"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import ExpenseTable from "./ExpenseTable"

const SubmittedExpenses = () => {
  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: expensesQuery,
    variables: { page },
  })

  if (result.data && result.data.expenses.data.length === 0) return null

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { expenses } }) => (
        <ExpenseTable
          title="Submitted Expenses"
          expenses={expenses}
          changePage={setPage}
        />
      )}
    </WithLoadingIndicator>
  )
}

const expensesQuery = gql`
  query SubmittedExpenses($page: Int!) {
    expenses(page: $page, state: submitted) {
      currentPage
      totalPages
      data {
        id
        expenseType
        description
        comments
        feedback
        formattedAmount
      }
    }
  }
`

export default SubmittedExpenses
